import Vue from 'vue'
import VueTouch from 'vue-touch'
Vue.use(VueTouch, { name: 'v-touch' })



// WEBPACK FOOTER //
// ./src/plugins/vue-touch.js